import type { Type } from '@angular/core';
import { ContentChild, Directive, inject } from '@angular/core';

import { TemplateResolver } from '../../utils/template-resolver';
import { DEFAULT_TRIGGER_COMPONENT, Select2TriggerComponent } from './trigger-default.component';
import { Select2TriggerDirective } from './trigger.directive';

@Directive({
  standalone: true,
  selector: 'rt-select2-trigger-resolver',
})
export class TriggerResolverDirective extends TemplateResolver<
  Select2TriggerDirective<any>,
  { optional: false }
> {
  @ContentChild(Select2TriggerDirective)
  public override contentDirective?: Select2TriggerDirective<any>;
  public override injectedComponent = <Type<Select2TriggerComponent>>(
    (<unknown>inject(Select2TriggerComponent, { optional: true }))
  );
  public override defaultComponent =
    inject(DEFAULT_TRIGGER_COMPONENT, { optional: true }) ?? Select2TriggerComponent;
}
